<template>
  <div>
    <div v-if="isTrustpilotLoading" class="animate-pulse bg-slate-200 rounded w-[200px] h-full">
      <div class="flex gap-2 ml-4 mb-2.5">
        <div class="h-3 bg-gray-200 rounded dark:bg-gray-700 max-w-[100px] w-full"></div>
        <div class="h-3 bg-gray-200 rounded dark:bg-gray-700 max-w-[100px] w-full"></div>
      </div>
      <div class="h-3 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[200px] ml-4"></div>
    </div>

    <div
      v-else
      class="trustpilot-widget"
      :data-template-id="props.templateId"
      :data-businessunit-id="businessUnitId"
      data-locale="nl-NL"
      data-text-color="#065CAB"
      data-theme="light"
      :data-style-width="props.width"
      :data-style-height="props.height"
      :style="{ width: props.width, height: props.height }"
    />
  </div>
</template>

<script setup lang="ts">
type TrustPilotProps = {
  templateId?: string;
  width?: string;
  height?: string;
}

const props = defineProps<TrustPilotProps>()
const appRegion = useRuntimeConfig().public.appRegion
const isTrustpilotLoading = ref(true)

const businessUnitId =
  appRegion === 'NL'
    ? '496b0cb30000640005040714'
    : '587ccaa10000ff00059ae12d'

onMounted(() => {
  const loadTrustpilotWidget = () => {
    isTrustpilotLoading.value = false
    nextTick(() => {
      const widget = document.querySelector('.trustpilot-widget')
      if (window.Trustpilot && widget) {
        window.Trustpilot.loadFromElement(widget)
      }
    })
  }

  if (!document.getElementById('trustpilot-script')) {
    const script = document.createElement('script')
    script.id = 'trustpilot-script'
    script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
    script.defer = true
    script.fetchPriority = 'low'
    document.head.appendChild(script)

    script.onload = loadTrustpilotWidget
    script.onerror = (err) => {
      console.warn('Trustpilot script failed to load:', err)
      isTrustpilotLoading.value = false
    }
  } else {
    loadTrustpilotWidget()
  }
})
</script>
